import { useCallback } from 'react';
import { AxiosRequestConfig } from 'axios';
import {
  LoginRequest,
  LoginResponse,
  GetOrganizationsResponse,
  CheckResponse,
  MigrateRequest,
  NoContentResult,
  CheckStatusResponse,
} from '@uniqkey-backend-organization-web/api-client';
import { useApiClients } from '../../contexts/APIClientsContext';
import { dataExtractor } from '../../../helpers/apiClients';

const useMigrationAPI = () => {
  const { migrationAPIClient, migrationLoginAPIClient } = useApiClients();

  const login = useCallback(
    (loginRequest: LoginRequest, options?: AxiosRequestConfig)
      : Promise<LoginResponse> => migrationLoginAPIClient
      .apiV1MigrationLoginPost(loginRequest, options)
      .then(dataExtractor<LoginResponse>()),
    [migrationLoginAPIClient],
  );

  const getOrganizations = useCallback(
    (options?: AxiosRequestConfig)
      : Promise<GetOrganizationsResponse> => migrationAPIClient
      .apiV1MigrationGetOrganizationsGet(options)
      .then(dataExtractor<GetOrganizationsResponse>()),
    [migrationAPIClient],
  );

  const check = useCallback(
    (
      organizationId: string,
      masterPasswordHash: string,
      options?: AxiosRequestConfig,
    ) => migrationAPIClient.apiV1MigrationCheckGet(
      organizationId,
      masterPasswordHash,
      options,
    ).then(dataExtractor<CheckResponse>()),
    [migrationAPIClient],
  );

  const migrate = useCallback(
    (migrateRequest?: MigrateRequest, options?: AxiosRequestConfig)
      : Promise<NoContentResult> => migrationAPIClient
      .apiV1MigrationMigratePost(migrateRequest, options)
      .then(dataExtractor<NoContentResult>()),
    [migrationAPIClient],
  );

  const checkStatus = useCallback(
    (currentGenOrganizationId?: string, options?: AxiosRequestConfig)
      : Promise<CheckStatusResponse> => migrationAPIClient
      .apiV1MigrationCheckStatusGet(currentGenOrganizationId, options)
      .then(dataExtractor<CheckStatusResponse>()),
    [migrationAPIClient],
  );

  return ({
    login,
    getOrganizations,
    check,
    migrate,
    checkStatus,
  });
};

export default useMigrationAPI;
